"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMap = exports.selectChartOptions = exports.selectCaption = exports.selectLayer = exports.selectSliceCount = exports.selectDonutRadius = exports.selectBand = exports.selectAreaIntersection = exports.selectFilters = exports.selectChartType = exports.selectAggregateFunction = exports.selectOrderBy = exports.selectSize = exports.selectColor = exports.selectCategory = exports.selectValue = exports.selectLimit = exports.selectVisualizationType = exports.selectDescription = exports.selectTitle = void 0;

var _reselect = require("reselect");

var _selectors = require("../editor/selectors");

var selectAvailableCharts = function selectAvailableCharts(state) {
  return state.configuration.availableCharts;
};

var selectRasterOnly = function selectRasterOnly(state) {
  return state.configuration.rasterOnly;
};

var selectTitle = function selectTitle(state) {
  return state.configuration.title;
};

exports.selectTitle = selectTitle;

var selectDescription = function selectDescription(state) {
  return state.configuration.description;
};

exports.selectDescription = selectDescription;

var selectVisualizationType = function selectVisualizationType(state) {
  return state.configuration.visualizationType;
};

exports.selectVisualizationType = selectVisualizationType;

var selectLimit = function selectLimit(state) {
  return state.configuration.limit;
};

exports.selectLimit = selectLimit;

var selectValue = function selectValue(state) {
  return state.configuration.value;
};

exports.selectValue = selectValue;

var selectCategory = function selectCategory(state) {
  return state.configuration.category;
};

exports.selectCategory = selectCategory;

var selectColor = function selectColor(state) {
  return state.configuration.color;
};

exports.selectColor = selectColor;

var selectSize = function selectSize(state) {
  return state.configuration.size;
};

exports.selectSize = selectSize;

var selectOrderBy = function selectOrderBy(state) {
  return state.configuration.orderBy;
};

exports.selectOrderBy = selectOrderBy;

var selectAggregateFunction = function selectAggregateFunction(state) {
  return state.configuration.aggregateFunction;
};

exports.selectAggregateFunction = selectAggregateFunction;

var selectChartType = function selectChartType(state) {
  return state.configuration.chartType;
};

exports.selectChartType = selectChartType;

var selectFilters = function selectFilters(state) {
  return state.configuration.filters;
};

exports.selectFilters = selectFilters;

var selectAreaIntersection = function selectAreaIntersection(state) {
  return state.configuration.areaIntersection;
};

exports.selectAreaIntersection = selectAreaIntersection;

var selectBand = function selectBand(state) {
  return state.configuration.band;
};

exports.selectBand = selectBand;

var selectDonutRadius = function selectDonutRadius(state) {
  return state.configuration.donutRadius;
};

exports.selectDonutRadius = selectDonutRadius;

var selectSliceCount = function selectSliceCount(state) {
  return state.configuration.sliceCount;
};

exports.selectSliceCount = selectSliceCount;

var selectLayer = function selectLayer(state) {
  return state.configuration.layer;
};

exports.selectLayer = selectLayer;

var selectCaption = function selectCaption(state) {
  return state.configuration.caption;
};

exports.selectCaption = selectCaption;
var selectChartOptions = (0, _reselect.createSelector)([selectAvailableCharts, selectRasterOnly, _selectors.selectDisabledFeatures], function (availableCharts, isRaster, disabledFeatures) {
  var res = availableCharts;

  if (isRaster) {
    // Currently, only map widgets can be created with raster datasets
    res = res.filter(function (option) {
      return option.value === 'map';
    });
  } // We filter out the visualization that are disabled by the host app


  res = res.filter(function (option) {
    return disabledFeatures.indexOf(option.value) === -1;
  });
  return res;
});
exports.selectChartOptions = selectChartOptions;
var isMap = (0, _reselect.createSelector)([selectChartType], function (chartType) {
  return chartType === 'map';
});
exports.isMap = isMap;